(function () {
    const binders = UX.binders,
        $body = $('body');

    binders._create = {
        binderName: '.binder__create__form__name',
        $binderName: $('.binder__create__form__name'),
        $binderDescription: $('.binder__create__form__desc'),
        $binderTable: $('.binder__table'),
        $toggle: $('.binder__create__form__create'),
        successMsg: '',
        rowElem: '',
        action: null,
        $rowTemplate: $('.binder__fake-row'),
        $rowShareTemplate: $('.binder__shared-fake-row'),
        noDescriptionMsg: $('.binder-list').data('no-desc-msg'),

        init() {
            this.control();
        },
        control() {
            $body.on('input', this.binderName, e => {
                let $this = $(e.target);
                this.$toggle = $this.closest('.binder__create__form').find('.binder__create__form__create');
                $this.val().trim() === ''
                    ? this.$toggle.attr('disabled', 'disabled')
                    : this.$toggle.removeAttr('disabled');
            });

            $body.on('click', '.binder-list__create-btn', () => {
                this.resetCreateForm();
            });

            $body.on('click', '.binder__append__btn', e => {
                e.preventDefault();
                let $this = $(e.target).hasClass('binder__append__btn')
                    ? $(e.target)
                    : $(e.target).closest('.binder__append__btn');
                $this.closest('#createBinder').length ? (this.action = 'create') : (this.action = 'duplicate');
                if ($this.closest('.save-to-binders__create').length) {
                    this.newBinder($this, 'create', true);
                } else {
                    this.newBinder($this, this.action, false);
                }

                if (this.action === 'create') {
                    $('#createBinder').modal('hide').find('input').val('');
                    this.$toggle.attr('disabled', 'disabled');
                }
            });
        },
        additionalControl() {},
        newBinder($elem, action, appendToSaveList) {
            let params = '';
            if (action === 'create') {
                let $createForm = $elem.parents('.binder__create__form'),
                    $binderNameInput = $createForm.find('.binder__create__form__name').val(),
                    binderDescriptionText =
                        $createForm.find('.binder__create__form__desc').val() !== ''
                            ? $createForm.find('.binder__create__form__desc').val()
                            : this.noDescriptionMsg;

                params = {binderName: $binderNameInput, binderDescription: binderDescriptionText};
                this.successMsg = binders.$alertMsg.data('create-success');
            } else {
                this.successMsg = binders.$alertMsg.data('duplicate-success');
            }

            let link = $elem.attr('data-append-newBinder-link');
            // let link = '/specs/ux3/widgets/binder-list/templates/demo/create.json'; //test link
            $.ajax({
                url: link,
                type: 'GET',
                data: params,
                success: function (data) {
                    if (data) {
                        binders._create.resetCreateForm($elem);
                        if (appendToSaveList) {
                            binders._create.appendToBinderList($elem, data);
                        } else {
                            binders._create.generateBinder(data);
                        }

                        binders.$alertMsg.html(binders.successHtml.replace(/{message}/g, binders._create.successMsg));
                    }
                },
            });
        },

        resetCreateForm($elem = {}) {
            $('.binder__create__form__name, .binder__create__form__desc').val('');
            $('.binder__create__form__create').attr('disabled', 'disabled');
            if ($elem.length) {
                let $createForm = $elem.closest('.binder__create__form');

                //for create binder from in save to binder component
                if ($createForm.hasClass('binder__create__form--mini')) {
                    $createForm.find('.binder__create__form__cancel').trigger('click');
                }
            }
            UX.charCount.init();
        },
        appendToBinderList: function ($elem, data) {
            $elem
                .parents('.save-to-binders')
                .find('.save-to-binders__list ul')
                .prepend(
                    '<li class="input-group"><label class="checkbox--primary" ' +
                        'tabindex="0"><input type="checkbox" name="binderCode" ' +
                        'value="' +
                        data.binderCode +
                        '" ' +
                        '><span class="label-txt"><div class="save-to-binders__list__binder-name">' +
                        data.binderName +
                        '</div></span></label></li>'
                );

            const $message = $(binders._create.successMsg);
            let view = 'list';
            if ($elem.parents('#saveToBinders-popup').length) {
                view = 'modal';
            }
            const $notificationTarget = $elem.parents('.save-to-binders').find('.save-to-binders__alerts');
            $elem.parents('.save-to-binders').find('.input-group input').first().trigger('click');
            UX.saveToBinder.showNotification($message, view, $notificationTarget);
        },
        generateBinder(data, shared) {
            shared = typeof shared !== 'undefined' ? shared : false;
            let trs = this.$binderTable.find('tbody tr').length,
                $rowStructre = shared ? this.$rowShareTemplate : this.$rowTemplate;

            if (data.binderDescription === undefined || data.binderDescription === null)
                data.binderDescription = `<span class='binder__list__no-description'>${this.noDescriptionMsg}</span>`;

            this.rowElem = $rowStructre[0].outerHTML
                .replace(/{code}/g, data.binderCode)
                .replace(/{name}/g, data.binderName)
                .replace(/{lastModifiedDate}/g, data.createDate)
                .replace(/{index}/g, trs)
                .replace(/{description}/g, data.binderDescription);

            let $binderElem = $(this.rowElem).removeClass('hidden binder__fake-row binder__share-fake-row');
            this.$binderTable.find('.empty--msg').remove();
            this.$binderTable.find('tbody').prepend($binderElem);

            setTimeout(function () {
                binders._create.$binderTable.find('.addedRow').removeClass('addedRow');
                $('.binder__alerts__msg').html('');
            }, 3000);
        },
    };
    if ($('.save-to-binders__ctrl').length) {
        UX.binders._create.init(); // for the mini form (Create a New Binder)
    }
})();
